import React, { Component } from "react";
import PropTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import clsx from "clsx";

import Badge from "components/badge/badge";
import {
    getCaseStatusColor,
    getCaseStatus,
} from "components/helpers/CaseStatus";

class OutlinedSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputId: props.inputId,
            name: props.name,
            value: props.value,
            label: props.label,
            labelWidth: 0,
            menuProps: {
                getContentAnchorEl: null,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                },
            },
        };

        this.inputLabel = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.setLabelWidth = this.setLabelWidth.bind(this);
    }

    componentDidMount() {
        this.setLabelWidth();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value,
        });
    }

    setLabelWidth() {
        this.setState({
            labelWidth: this.inputLabel.current.offsetWidth,
        });
    }

    handleChange(event) {
        const { onChange } = this.props;
        onChange(event.target.value);
        this.setState({
            value: event.target.value,
        });
    }

    renderOptions() {
        if (!this.props.options) return;
        const { options } = this.props;
        let optionsList = [];
        options?.forEach((i) => {
            optionsList.push(
                <MenuItem value={i.value} key={i.value}>
                    {this.props?.isCommentary ? (
                        <Badge color={getCaseStatusColor(i.value)}>
                            {i.label}
                        </Badge>
                    ) : (
                        i.label
                    )}
                </MenuItem>
            );
        });
        return optionsList;
    }

    render() {
        let {
            classes,
            onClick,
            onMouseOver,
            disabled,
            children,
            displayDefault,
            displayBadge = false,
        } = this.props;
        return (
            <FormControl
                variant="outlined"
                className={clsx("outlined-select-form-control", classes)}
                disabled={disabled}
            >
                <InputLabel ref={this.inputLabel} htmlFor={this.state.inputId}>
                    {this.state.label}
                </InputLabel>
                <Select
                    onClick={onClick}
                    onMouseOver={onMouseOver}
                    value={this.state.value}
                    onChange={this.handleChange}
                    MenuProps={this.state.menuProps}
                    displayEmpty={true}
                    input={
                        <OutlinedInput
                            labelWidth={this.state.labelWidth}
                            name={this.state.name}
                            id={this.state.inputId}
                            className="outlined-select-input"
                        />
                    }
                    renderValue={
                        displayBadge
                            ? (value) => {
                                  if (!value && value !== 0) {
                                      return <>Select Status</>;
                                  }
                                  return (
                                      <Badge
                                          color={getCaseStatusColor(
                                              Number(value)
                                          )}
                                      >
                                          {getCaseStatus(`${value}`)}
                                      </Badge>
                                  );
                              }
                            : null
                    }
                >
                    {displayDefault && (
                        <MenuItem value="">Please Select</MenuItem>
                    )}
                    {this.renderOptions()}
                    {children}
                </Select>
            </FormControl>
        );
    }
}

OutlinedSelect.propTypes = {
    inputId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    classes: PropTypes.string,
    options: PropTypes.array,
    displayDefault: PropTypes.bool,
};

OutlinedSelect.defaultProps = {
    // options: [{ value:'1', label:'Option One' },{ value:'2', label:'Option Two' },{ value:'3', label:'Option Three' }],
    onChange: () => {},
    displayDefault: false,
};

export default OutlinedSelect;
